import { render, staticRenderFns } from "./divider.vue?vue&type=template&id=526a1a7a&"
import script from "./divider.vue?vue&type=script&lang=js&"
export * from "./divider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangbin/workspace/project/bin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('526a1a7a')) {
      api.createRecord('526a1a7a', component.options)
    } else {
      api.reload('526a1a7a', component.options)
    }
    module.hot.accept("./divider.vue?vue&type=template&id=526a1a7a&", function () {
      api.rerender('526a1a7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/divider/divider.vue"
export default component.exports